module.exports = __webpack_public_path__ + "static/assets/bfe2775a023ddfadc6036aaedc82b9d2.svg";